import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Calendar, Users, Award, TrendingUp, Play, Pause, SkipBack, Gem } from 'lucide-react';
interface RewardDetailDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  reward: {
    id: number;
    name: string;
    status: string;
    redemptions: number;
    diamondsSpent: number;
    lastRedemption: string;
    category: string;
    availability: number;
    totalAvailability: number;
  } | null;
}
const RewardDetailDrawer: React.FC<RewardDetailDrawerProps> = ({
  isOpen,
  onClose,
  reward
}) => {
  const navigate = useNavigate();
  if (!reward) return null;
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'Attivo':
        return <Play className="h-4 w-4 text-green-600" data-id="element-581" />;
      case 'Programmato':
        return <Calendar className="h-4 w-4 text-blue-600" data-id="element-582" />;
      case 'In Scadenza':
        return <Pause className="h-4 w-4 text-amber-600" data-id="element-583" />;
      case 'Esaurito':
        return <SkipBack className="h-4 w-4 text-gray-600" data-id="element-584" />;
      default:
        return null;
    }
  };
  const handleViewDetails = () => {
    navigate(`/rewards/${reward.id}`);
    onClose();
  };
  return <>
      {/* Backdrop */}
      {isOpen && <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={onClose} data-id="element-585"></div>}

      {/* Drawer */}
      <div className={`fixed top-0 right-0 h-full w-full sm:w-96 bg-white shadow-xl z-50 overflow-y-auto transition-transform duration-300 ease-in-out ${isOpen ? 'transform-none' : 'translate-x-full'}`} data-id="element-586">
        <div className="p-6" data-id="element-587">
          {/* Header */}
          <div className="flex items-center justify-between mb-6" data-id="element-588">
            <h2 className="text-xl font-semibold" data-id="element-589">Dettagli Premio</h2>
            <button onClick={onClose} className="rounded-full p-2 hover:bg-gray-100 transition-colors" data-id="element-590">
              <X className="h-5 w-5 text-gray-500" data-id="element-591" />
            </button>
          </div>

          {/* Reward Info */}
          <div className="space-y-6" data-id="element-592">
            {/* Name and Status */}
            <div data-id="element-593">
              <h3 className="text-lg font-medium mb-2" data-id="element-594">{reward.name}</h3>
              <div className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gray-50" title={reward.status} data-id="element-595">
                {getStatusIcon(reward.status)}
              </div>
            </div>

            {/* Category */}
            <div className="flex items-center text-sm text-gray-600" data-id="element-596">
              <Award className="h-4 w-4 mr-2" data-id="element-597" />
              <span data-id="element-598">Categoria: {reward.category}</span>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-4" data-id="element-599">
              <div className="p-4 bg-gray-50 rounded-lg" data-id="element-600">
                <div className="flex items-center text-gray-500 text-xs mb-1" data-id="element-601">
                  <TrendingUp className="h-3 w-3 mr-1" data-id="element-602" />
                  Riscatti
                </div>
                <div className="text-2xl font-semibold" data-id="element-603">
                  {reward.redemptions}
                </div>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg" data-id="element-604">
                <div className="flex items-center text-gray-500 text-xs mb-1" data-id="element-605">
                  <Gem className="h-3 w-3 mr-1" data-id="element-606" />
                  Diamond Spesi
                </div>
                <div className="text-2xl font-semibold" data-id="element-607">
                  {reward.diamondsSpent}
                </div>
              </div>
            </div>

            {/* Availability */}
            <div data-id="element-608">
              <div className="flex justify-between text-sm mb-2" data-id="element-609">
                <span className="text-gray-600" data-id="element-610">Disponibilità</span>
                <span className="font-medium" data-id="element-611">
                  {reward.availability} / {reward.totalAvailability}
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-612">
                <div className="bg-greenback rounded-full h-2" style={{
                width: `${reward.availability / reward.totalAvailability * 100}%`
              }} data-id="element-613"></div>
              </div>
            </div>

            {/* Last Redemption */}
            <div className="flex items-center text-sm text-gray-600" data-id="element-614">
              <Calendar className="h-4 w-4 mr-2" data-id="element-615" />
              <span data-id="element-616">Ultimo riscatto: {reward.lastRedemption}</span>
            </div>

            {/* Actions */}
            <div className="pt-4 border-t border-gray-200" data-id="element-617">
              <button onClick={handleViewDetails} className="w-full px-4 py-2 bg-greenback text-white rounded-full hover:bg-greenback-600 transition-colors" data-id="element-618">
                Vedi Dettagli Premio
              </button>
            </div>
          </div>
        </div>
      </div>
    </>;
};
export default RewardDetailDrawer;